export default function MessageSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#ECFDF5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Message
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            私からのメッセージ
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-2/5 flex-shrink-0 bg-white flex items-end">
                <img
                  src="https://storage.readdy-site.link/project_files/dd63e7f2-2ad5-4550-918c-a85f51c054ca/1ed97b1f-64a4-4b24-b87a-ffef0b16710b_IMG_8681.png?v=89958587764ee4bdedd344faa7f0b87b"
                  alt="吉柴隆樹"
                  className="w-full h-auto block"
                />
              </div>

              <div className="flex-1 p-10 md:p-12">
                <div className="space-y-8 text-[#333333] leading-relaxed">
                  <div className="relative pl-8 border-l-4 border-[#10B981]">
                    <p className="text-2xl font-bold text-[#065F46] mb-4" style={{ lineHeight: '1.8' }}>「もう良くならない」</p>
                    <p className="text-base" style={{ lineHeight: '2.0' }}>そう思っている方も多いと思います。</p>
                  </div>

                  <p className="text-base" style={{ lineHeight: '2.0' }}>
                    ですが、身体の使い方が変わることで、痛みや不調が改善していく可能性があります。
                  </p>

                  <div className="bg-[#ECFDF5] rounded-2xl p-8 my-8">
                    <p className="text-xl text-[#065F46] font-medium text-center" style={{ lineHeight: '2.0' }}>
                      あなたの身体には<br />
                      本来の力があります。
                    </p>
                  </div>

                  <p className="text-base" style={{ lineHeight: '2.0' }}>
                    理学療法士としての知識と整体の技術を融合し、痛みの原因にしっかりアプローチします。
                  </p>

                  <p className="text-base" style={{ lineHeight: '2.0' }}>
                    その力を引き出すお手伝いができれば嬉しく思います。
                  </p>

                  <div className="pt-8 border-t border-gray-200">
                    <div className="text-right">
                      <p className="text-xl font-bold text-[#065F46]" style={{ fontFamily: "'Noto Serif JP', serif" }}>吉柴　隆樹</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <button
              onClick={scrollToContact}
              className="inline-flex items-center gap-3 px-10 py-4 bg-[#10B981] text-white text-lg font-bold rounded-full hover:bg-[#059669] transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              <span>訪問整体のご相談はこちら</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
